var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowCarousel = function SvgArrowCarousel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53.5,
    y: 53.5,
    width: 53,
    height: 53,
    rx: 26.5,
    transform: "rotate(180 53.5 53.5)",
    fill: "#fff",
    stroke: "#B6B4AA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.375 36 20.25 27l10.125-9",
    stroke: "#25241D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgArrowCarousel as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTQiIGhlaWdodD0iNTQiIHZpZXdCb3g9IjAgMCA1NCA1NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iNTMuNSIgeT0iNTMuNSIgd2lkdGg9IjUzIiBoZWlnaHQ9IjUzIiByeD0iMjYuNSIgdHJhbnNmb3JtPSJyb3RhdGUoMTgwIDUzLjUgNTMuNSkiIGZpbGw9IndoaXRlIiBzdHJva2U9IiNCNkI0QUEiLz4KPHBhdGggZD0iTTMwLjM3NSAzNkwyMC4yNSAyN0wzMC4zNzUgMTgiIHN0cm9rZT0iIzI1MjQxRCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";